import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function createProductIdValidator(id: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return value === id ? { sameProduct: true } : null;
  }
}